import type { CellProps } from 'react-table';
import ClickContainer from './ResultClickContainer';
import type { ProjectsTableItem } from './interfaces';
import styles from './style/Cell.Name.module.css';
import ProjectIcon from '@/components/icons/ProjectIcon';

export default function Name({ row: { original: data } }: CellProps<ProjectsTableItem>) {
  return (
    <ClickContainer className={styles.overflowWrapper} item={data}>
      <div className={styles.root}>
        <ProjectIcon
          className={styles.icon}
          projectTypeId={data.metadata.type} />
        <div className={styles.details}>
          <div className={styles.name}>{data.name}</div>
        </div>
      </div>
    </ClickContainer>
  );
}

export { Name };